import { TextButton } from 'sharedComponents/Buttons';
import { useMediaQuery, Theme } from '@mui/material';
import { NAVBAR_BUTTON_LABELS } from 'utils/constants';
import { secondaryButtonStyles } from './styles';

export const SupportButton: React.FC = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const contactSupportOnClickHandler = () => {
    window.location.href = 'mailto:connectsupport@hirenimble.com';
  };

  return (
    <TextButton onClick={contactSupportOnClickHandler} sx={secondaryButtonStyles}>
      {isMobile ? NAVBAR_BUTTON_LABELS.MOBILE_SUPPORT : NAVBAR_BUTTON_LABELS.DESKTOP_SUPPORT}
    </TextButton>
  );
};
